var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divPage" },
    [
      _c(
        "md-layout",
        { staticClass: "error-page", attrs: { "md-column": "" } },
        [
          _c("div", { staticClass: "logoContainer" }, [
            _c("img", {
              attrs: {
                src: require("../assets/img/RhebusTV_logo.jpg"),
                "md-align": "center",
                width: "350px"
              }
            })
          ]),
          _c("md-layout", { attrs: { "md-align": "center" } }, [
            _c(
              "div",
              { staticClass: "error-card", attrs: { "md-elevation": "3" } },
              [
                _c("h1", [_vm._v("404")]),
                _c(
                  "p",
                  { staticClass: "alert" },
                  [
                    _c("md-icon", { staticClass: "on-left md-accent" }),
                    _vm._v("Oops. Nothing here...")
                  ],
                  1
                ),
                _vm.canGoBack
                  ? _c(
                      "md-button",
                      {
                        staticClass: "md-primary md-raised",
                        on: { click: _vm.goBack }
                      },
                      [
                        _c("md-icon", {
                          staticClass: "colorIcons",
                          attrs: { "md-iconset": "fa fa-arrow-left" }
                        }),
                        _vm._v("Go back")
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "router-link",
                  { attrs: { to: "/" } },
                  [
                    _c(
                      "md-button",
                      { staticClass: "md-primary md-raised" },
                      [
                        _vm._v("Go home"),
                        _c("md-icon", {
                          staticClass: "colorIcons on-right",
                          attrs: { "md-iconset": "fa fa-home" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c28bbf3", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c28bbf3","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/spa/NotFound.vue
// module id = 1043
// module chunks = 0